import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doSignUp: UseCase<AuthRepository, 'signUp'> = repository => {
  return async signUp => {
    return await repository.signUp(signUp)
  }
}
